import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import type { ObjectPassportFieldDefinition } from '@/entities/Inventory/ObjectPassportFields'

/** Нормализованное определение поля + legacy-id (GET /object-types/:id/fields). */
export type NormalizedFieldValidationSource = ObjectPassportFieldDefinition & {
  legacy_field_id?: string | null
}

function definitionMatchesField(
  def: NormalizedFieldValidationSource,
  fieldId: string,
): boolean {
  return String(def.id) === fieldId || String(def.legacy_field_id ?? '') === fieldId
}

function withValidationProps(
  field: ObjectInventoryField,
  def: NormalizedFieldValidationSource,
): ObjectInventoryField {
  const vp = def.validation_props ?? {}
  return {
    ...field,
    min: field.min ?? (vp.min as number | string | undefined),
    max: field.max ?? (vp.max as number | string | undefined),
    length: field.length ?? (vp.length as number | undefined),
    precision: field.precision ?? (vp.precision as number | undefined),
    use_min: field.use_min ?? (vp.use_min as boolean | undefined),
    use_max: field.use_max ?? (vp.use_max as boolean | undefined),
    /** Обязательность — как в паспорте: нормализованный `is_required` главнее legacy `mandatory`. */
    mandatory: Boolean(def.is_required),
  }
}

/**
 * Поднимает min/max/length/precision из `validation_props` нормализованных определений
 * (GET /object-types/:id/fields) в legacy-метаданные полей: legacy object-types API
 * не отдаёт validation_props, и InventTypeField теряет ограничения (например, min >= 0).
 */
export function enrichInventoryFieldValidationProps(
  fields: ObjectInventoryField[],
  definitions: NormalizedFieldValidationSource[] | null | undefined,
): ObjectInventoryField[] {
  if (!definitions?.length) return fields
  return fields.map((field) => {
    const def = definitions.find((d) => definitionMatchesField(d, String(field.id)))
    return def ? withValidationProps(field, def) : field
  })
}
